import ATB from './assets/Aalo.png';
import CB from './assets/Cb.png';
import ff from './assets/frenchfries.png';
import vm from './assets/Veg Momos.png';
import manchurian from './assets/manchurian.png';

export const data = [
    {
        name: "Aalo Tikki Burger",
        price: "50",
        img: ATB
    }
    ,

    {
        name: "French Fries",
        price: "150",
        img: ff
    }

    ,
    {
        name: "Veg Momos",
         price: "200",
        img: vm
    }

    ,
    {
        name: "Aalo Tikki Burger",
        price: "50",
        img: ATB
    }
    ,

    {
        name: "French Fries",
        price: "150",
        img: ff
    }

    ,
    {
        name: "Veg Momos",
         price: "200",
        img: vm
    }

    ,
    {
        name: "Manchurian",
        price: "120",
        img: manchurian
    }

    ,
    {
        name: "Cheese Burger",
        price: "100",
        img: CB
    }

    ,
    {
        name: "Veg Burger",
        price: "30",
        img: ATB
    }
    ,

];
